export const GET_CHAT_CONVERSATION_LIST = null;
export const SELECTED_CHAT_CONVERSATION_ID = null;